



















import mixins from 'vue-typed-mixins';
import SurveyGroupForm from '@/components/survey/management/SurveyGroupForm.vue';
import { SurveyGroup } from '../../utils/SurveyUtils';
import SurveyUtils from '../../utils/SurveyUtils';
export default mixins().extend({
  components: {
    SurveyGroupForm,
  },
  computed: {
    id(): number | undefined {
      const id = parseInt(this.$route.params.id);
      return !isNaN(id) ? id : undefined;
    },
  },
  data(): {
    group?: Partial<SurveyGroup>;
  } {
    return {
      group: {
        name: undefined,
        state: 'inactive',
        dashboard: {
          canvas: {
            left: [],
            right: [],
          },
        },
      },
    };
  },
  methods: {
    async submit() {
      if (this.group) {
        try {
          this.$alert.hide('submit');
          this.group.state = 'inactive';
          await SurveyUtils.api.surveyGroup.add(this.group as SurveyGroup);
          await this.$router.push({ name: 'survey-group-list' });

          this.$toast.push({
            type: 'success',
            text: this.$languageobj('validation.success.add', {
              values: [this.group.name],
            }),
          });
        } catch (error) {
          this.$alert.show('submit', {
            type: 'error',
            messages: this.$handleAPIError(error, this.$refs.observer),
          });
        }
      }
    },
  },
});
